var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-wrap",class:`${_vm.lazyloading ? 'media-wrap--lazy-loader ' : ''}media-wrap--${_vm.size}`},[_c('img',{staticClass:"media-item cover-img",class:_vm.lazyloading ? 'lazy' : '',attrs:{"src":_vm.lazyloading ? '' : _vm.src,"data-src":_vm.lazyloading ? _vm.src : undefined,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }